import React, { useState } from 'react';
import { API, C, GENRES } from '../constants';

export default function EditInfoModal({ media, info, token, onClose, onSaved }) {
  const [form, setForm] = useState({
    title:    info?.title    || media.name,
    synopsis: info?.synopsis || '',
    year:     info?.year     || '',
    genre:    info?.genre    || '',
    director: info?.director || '',
    duration: info?.duration || '',
  });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const save = async () => {
    setSaving(true); setMsg('');
    // Sin try, un fallo de red dejaba el botón en "guardando" para siempre.
    try {
      const res = await fetch(`${API}/api/media-info`, {
        method:'POST',
        headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${token}` },
        body: JSON.stringify({ file_name: media.file, title: form.title, synopsis: form.synopsis, year: parseInt(form.year) || 0, genre: form.genre, director: form.director, duration: parseFloat(form.duration) || 0 })
      });
      if (res.ok) { setMsg('✓ Guardado'); onSaved(); } else setMsg('Error al guardar');
    } catch { setMsg('Error de conexión'); }
    setSaving(false);
  };

  const inp = { width:'100%', padding:'10px 14px', borderRadius:'8px', background:'rgba(255,255,255,0.04)', border:`1px solid ${C.accentBorder}`, color:C.text, fontSize:'14px', outline:'none', boxSizing:'border-box', fontFamily:'Inter, sans-serif', marginBottom:'12px' };

  return (
    <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.85)', zIndex:600, display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' }}>
      <div onClick={e => e.stopPropagation()} style={{ background:C.bgModal, border:`1px solid ${C.accentBorder}`, borderRadius:'16px', width:'100%', maxWidth:'520px', maxHeight:'90vh', overflow:'hidden', display:'flex', flexDirection:'column', boxShadow:'0 32px 80px rgba(0,0,0,0.8)' }}>
        <div style={{ padding:'20px 24px', borderBottom:`1px solid ${C.border}`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <h3 style={{ fontFamily:'Playfair Display, serif', color:C.text, fontSize:'18px' }}>Editar información</h3>
          <button onClick={onClose} style={{ background:'transparent', border:'none', color:C.textMuted, cursor:'pointer', fontSize:'20px' }}>✕</button>
        </div>
        <div style={{ padding:'20px 24px', overflowY:'auto', flex:1 }}>
          <p style={{ color:C.textDim, fontSize:'11px', marginBottom:'14px' }}>Archivo: {media.file}</p>
          <p style={{ color:C.textMuted, fontSize:'12px', marginBottom:'4px' }}>Título</p>
          <input placeholder="Título" value={form.title} onChange={e => setForm({...form, title:e.target.value})} style={inp} />
          <p style={{ color:C.textMuted, fontSize:'12px', marginBottom:'4px' }}>Sinopsis</p>
          <textarea placeholder="Escribe la sinopsis..." value={form.synopsis} onChange={e => setForm({...form, synopsis:e.target.value})} style={{ ...inp, height:'90px', resize:'vertical' }} />
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px' }}>
            <div>
              <p style={{ color:C.textMuted, fontSize:'12px', marginBottom:'4px' }}>Año</p>
              <input placeholder="2024" type="number" value={form.year} onChange={e => setForm({...form, year:e.target.value})} style={inp} />
            </div>
            <div>
              <p style={{ color:C.textMuted, fontSize:'12px', marginBottom:'4px' }}>Duración (seg)</p>
              <input placeholder="5400" type="number" value={form.duration} onChange={e => setForm({...form, duration:e.target.value})} style={inp} />
            </div>
          </div>
          <p style={{ color:C.textMuted, fontSize:'12px', marginBottom:'4px' }}>Género</p>
          <select value={form.genre} onChange={e => setForm({...form, genre:e.target.value})} style={{ ...inp, cursor:'pointer' }}>
            <option value="">Sin género</option>
            {GENRES.map(g => <option key={g} value={g}>{g}</option>)}
          </select>
          <p style={{ color:C.textMuted, fontSize:'12px', marginBottom:'4px' }}>Director</p>
          <input placeholder="Nombre del director" value={form.director} onChange={e => setForm({...form, director:e.target.value})} style={inp} />
          {msg && <p style={{ color: msg.includes('✓') ? C.success : '#e07a5f', fontSize:'13px', marginBottom:'12px' }}>{msg}</p>}
          <button onClick={save} disabled={saving} style={{ width:'100%', padding:'12px', background:`linear-gradient(135deg, ${C.accent}, ${C.accentSoft})`, border:'none', color:'#fff', borderRadius:'10px', cursor: saving ? 'not-allowed' : 'pointer', fontSize:'14px', fontWeight:'600', fontFamily:'Inter, sans-serif' }}>
            {saving ? 'Guardando...' : 'Guardar cambios'}
          </button>
        </div>
      </div>
    </div>
  );
}
